import { useState } from 'react';
import styled from 'styled-components';

import { TransactionActions } from '@store';
import { Box, Input, Button, Loading, Text } from '@components/common';
import { useAppDispatch } from '@hooks';
import { MysteryForestImage } from '@src/client/assets/images';

const Background = styled(Box)`
  background-image: ${`url(${MysteryForestImage})`};
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;

const PAUSED = false;

export const Portal = () => {
  const dispatch = useAppDispatch();
  const [lootId, setLootId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  return (
    <Background center flex={1}>
      <Box center>
        <Input
          type="text"
          value={lootId}
          onChange={(e) => setLootId(e.target.value)}
          placeholder="Loot ID"
          center
          mb={2}
        />
        <Button
          onClick={async () => {
            setIsLoading(true);
            await dispatch(
              TransactionActions.warp({ lootId: parseInt(lootId) })
            );
            setIsLoading(false);
          }}
          disabled={lootId === '' || isLoading || PAUSED}
        >
          WARP
          {isLoading && (
            <Box ml={1}>
              <Loading color="secondary" size={18} />
            </Box>
          )}
        </Button>
        {PAUSED && (
          <Text
            color="error"
            fontWeight="bold"
            mt={2}
            width={200}
            textAlign="center"
          >
            Warp Under Maintenance
          </Text>
        )}
      </Box>
    </Background>
  );
};
